<p-tabs value="{{activeTabIndex}}">
    <p-tablist style="display: flex; align-items: center; justify-content: space-between;"
        class="container-style px-0 py-1">
        <p-tab (click)="handleTabChange(0)" value="0">Consulta General</p-tab>
        <p-tab (click)="handleTabChange(1)" value="1">Consulta Detalle</p-tab>
        <app-custom-button class="widthBtns" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
            [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
            (onClick)="newRegister()"></app-custom-button>
    </p-tablist>
    <p-tabpanels class="container-style mt-2">
        <p-tabpanel value="0">
            <app-custom-table [showExport]="true" [showRecover]="true" [headers]="generalHeader" [data]="generalData"
                [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="url"
                (onRecoverData)="getAllMasterSolutionsWithPagination()" (onPageChange)="onPageChange($event)"
                (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
                (onAction)="onAction($event)"></app-custom-table>
        </p-tabpanel>
        <p-tabpanel value="1">
            <app-custom-table [showExport]="true" [showRecover]="true" [headers]="detailHeader" [data]="detailData"
                [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="url"
                (onRecoverData)="getAllMasterSolutionDetailsWithPagination()" (onPageChange)="onPageChange($event)"
                (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
                (onAction)="onAction($event)"></app-custom-table>
        </p-tabpanel>
    </p-tabpanels>
</p-tabs>